// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './util/init';
import Vue from 'vue';
import VueResource from 'vue-resource';
import App from './App';
import router from './router';
import './js/historyRouter';
import './config/env';
import './config/rem';
import Toast from './js/toast';
import Loading from './js/loadingx';
import { store } from './store/store';
import vueTap from 'v-tap'; // 引入插件
import { getQueryCode } from './service/getData';
import { PROXY_URL } from './config/env';
import 'vant/lib/index.css';
import { Dialog, Tab, Tabs, Icon, Button, Collapse, CollapseItem, Popup, Uploader, Form, Field, Picker, Cell, CellGroup } from 'vant';
import moment from 'moment';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import md5 from 'js-md5';
import { EventReport } from './util/eventReport';
import shanyanJs from './js/shanyan';
Vue.use(Antd);
Vue.use(Form);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Dialog);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popup);

// import axios from 'axios'
// axios.defaults.withCredentials=true;

Vue.config.productionTip = false;
Vue.use(Toast); // toast 组件
Vue.use(Loading); // toast 组件
Vue.use(VueResource);
Vue.use(vueTap);
Vue.prototype.$moment = moment;
Vue.prototype.$md5 = md5;

shanyanJs.shanyanSetUiConfig();

shanyanJs.shanyanInit();
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	} else if (to.path !== '/wxpay' && to.path !== '/weipay/wxpay' && to.path !== '/blank') {
		document.title = '虚贝租号-专业游戏租号平台-LOL、CF租号首选';
	}

	if (window.location.pathname.indexOf('weipay') > -1 && to.path !== '/weipay/wxpay') {
		window.location.href = window.location.origin + '/#' + window.location.pathname + window.location.search;
	}

	// 埋点
	if (from.path == '/' || from.path == '/goodslist') {
		let pageId = '';
		if (from.path == '/') {
			pageId = '首页列表';
		} else if (from.query.searchText && from.path == '/goodslist') {
			pageId = '搜索列表';
		} else if (!from.query.searchText && from.path == '/goodslist') {
			pageId = '单类目列表';
		}
		if (Number(to.query.stickorder)) {
			if (to.path == '/goodsdetail') {
				sessionStorage.setItem('entryId', `${pageId}-${to.query.itemIndex}-h5_m`);
			}
			let params = {
				business: {
					actionId: 'apphome_page_click',
					gameId: to.query.gameId,
					businessType: 1,
					position: to.query.itemIndex,
					topFlag: to.query.stickorder
				},
				page: {
					pageId
				}
			};
			EventReport(params);
		}
	}
	// 删除埋点数据
	if (from.path == '/goodsdetail') {
		if (to.path != '/order') {
			sessionStorage.removeItem('entryId');
		}
	}
	// 删除埋点数据
	if (from.path == '/order') {
		if (to.path != '/goodsdetail') {
			sessionStorage.removeItem('entryId');
		}
	}

	try {
		// 页面埋点
		if (to.path == '/' || ['/goodslist', '/goodsdetail', '/login'].includes(to.path)) {
			let params = {
				business: {
					actionId: 'index_page_view',
					businessType: 1
				},
				page: {
					pageId: to.path
				}
			};
			let source = null;
			switch (to.path) {
				case '/':
					break;
				case '/goodslist':
					// source 用户访问来源：1.首页 2.游戏分类 3.其他
					if (from.path === '/') {
						source = 1;
					} else if (from.path === '/goodsAll') {
						source = 2;
					} else {
						source = 3;
					}
					params.business.actionId = 'list_detail_view';
					params.business.gameId = to.query.gameId;
					params.page.source = source ? source : 3;
					break;
				case '/goodsdetail':
					// source 用户访问来源：1.首页 2.商品列表 3.其他
					if (from.path === '/') {
						source = 1;
					} else if (from.path === '/goodslist') {
						source = 2;
					} else {
						source = 3;
					}
					params.business.actionId = 'goods_detail_view';
					params.business.gameId = to.query.gameId;
					params.page.source = source ? source : 3;
					break;
				case '/login':
					// source 用户访问来源：1.新人活动 2.订单 3.我的 4.详情页 5.其他
					if (to.query && to.query.redirect) {
						if (to.query.redirect.includes('welfare')) {
							source = 1;
						} else if (to.query.redirect.includes('my_order')) {
							source = 2;
						} else if (to.query.redirect.includes('/my')) {
							source = 3;
						} else if (to.query.redirect.includes('goodsdetail')) {
							source = 4;
						} else {
							source = 5;
						}
					} else {
						source = 5;
					}
					params.business.actionId = 'register_view';
					params.page.source = source ? source : 3;
					break;
				default:
					break;
			}
			EventReport(params);
		}
	} catch (e) {}

	if (to.matched.some((record) => record.meta.requireAuth)) {
		// 判断该路由是否需要登录权限
		if (store.state.userInfo && store.state.userInfo.userid) {
			// 判断当前的token是否存在
			next();
		} else {
			next({
				path: '/login',
				query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
			});
		}
	} else {
		next();
	}

	if (to.path) {
		// 百度统计
		setTimeout(function() {
			var _hmt = _hmt || [];
			(function() {
				var hm = document.createElement('script');
				hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(hm, s);
			})();
		}, 0);

		if (to.path.indexOf('weipay') > -1) {
			(function() {
				var wp = document.createElement('script');
				wp.src = 'http://bs.linkh5.com/js/kfcm-zhuxiang-18971379122.js';
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(wp, s);
			})();
		}
	}
});

/* eslint-disable no-new */

new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',

	data: {},
	mounted() {
		// this.creatJs()
	},

	methods: {
		creatJs: function() {
			var head = document.getElementsByTagName('head')[0];
			var script = document.createElement('script');
			script.setAttribute('id', 'codejs');
			head.appendChild(script);
		}
	}
});

Vue.prototype.$isWX = function() {
	// var ua = navigator.userAgent.toLowerCase();
	// var isWeixin = ua.indexOf('micromessenger') != -1;
	// if (isWeixin) {
	//   window.isNotWx = false;
	//   if(this.$route.query.openId){
	//     return this.$route.query.openId;
	//   }else{
	//     window.location.href = `${PROXY_URL.config}/xubei-common-cloud/anon/wechat/gzh/oauth2/authorize?returnUrl=${encodeURIComponent(window.location.href)}`
	//     return false
	//   }

	// }else{
	window.isNotWx = true;
	return false;
	// }
};



// WEBPACK FOOTER //
// ./src/main.js